import { Controller } from "@hotwired/stimulus"

// Mobile sidebar toggle (slide-out drawer)
// Registered as "docs--layout"
export default class extends Controller {
  static targets = ["sidebar", "overlay"]

  connect() {
    // Close the sidebar before Turbo snapshots the page so the cache never
    // captures the overlay in its visible state. Without this, hitting Back
    // would restore the snapshot with the full-viewport overlay visible,
    // blocking all pointer events and making the page appear unscrollable.
    this._boundBeforeCache = () => this.closeSidebar()
    document.addEventListener("turbo:before-cache", this._boundBeforeCache)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this._boundBeforeCache)
    this.closeSidebar()
  }

  toggleSidebar() {
    const isOpen = !this.sidebarTarget.classList.contains("-translate-x-full")
    if (isOpen) {
      this.closeSidebar()
    } else {
      this.openSidebar()
    }
  }

  openSidebar() {
    this.sidebarTarget.classList.remove("-translate-x-full")
    this.sidebarTarget.classList.add("translate-x-0")
    this.overlayTarget.classList.remove("hidden")
  }

  closeSidebar() {
    this.sidebarTarget.classList.add("-translate-x-full")
    this.sidebarTarget.classList.remove("translate-x-0")
    this.overlayTarget.classList.add("hidden")
  }
}
